import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-entregaARenidr-glosa', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FECHA' htmlFor='date-entregaARenidr-fechaEmision' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-entregaARenidr-fechaEmision'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
